export default {
  RedressNumberFormField__ARIA: "Redress number",
  RedressNumberFormField__INFO_TIP_ARIA: (label) => `More information about ${label}`,
  RedressNumberFormField__LABEL: "Redress number",
  RedressNumberFormField__OPTIONAL: "Optional",
};
